<template>
  <el-row>
    <table-template  @onDataFilter="onDataFilter" :queryParams="queryParams" actionUrl="/channel/findChannelUsedCarSwitch.action"
                    ref="usedCarSouceSwitchManagementTable">
      <template slot="search">
      </template>
      <template slot="item">
        <el-table-column
            label="名称"
            prop="name">

        </el-table-column>
        <el-table-column label="模块说明" prop="desc">

        </el-table-column>
        <el-table-column
            label="显示状态"
            >
        <template scope="scope">
          <el-switch
              style="display: block"
              v-model="scope.row.switch"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="2"
              active-text="显示"
              inactive-text="隐藏"
              @change="changeSwitch(scope.$index,scope.row)"
             >
          </el-switch>
        </template>
        </el-table-column>

      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import channelModel from '@/framework/models/channelModel'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'used-car-source-switch-config-management',
  data: function () {
    return {
      queryParams: {},
      data: [],
      channelId: null
    }
  },
  created () {
    let loginInfo = this.loginInfo
    this.channelId = loginInfo.id
  },
  methods: {
    changeSwitch (index, row) {
      var that = this

      let data = {
        key: null,
        val: null
      }
      switch (index) {
        case 0:
          data.key = 'carSourceSwitch'
          data.val = row.switch
          break
        case 1:
          data.key = 'clueSourceSwitch'
          data.val = row.switch
          break
      }

      that.saveData(data)
    },

    saveData: function (data) {
      debugger
      let that = this
      let param
      if (data.key === 'carSourceSwitch') {
        param = {
          carSourceSwitch: data.val,
          id: this.channelId
        }
      }
      if (data.key === 'clueSourceSwitch') {
        param = {
          clueSourceSwitch: data.val,
          id: this.channelId
        }
      }
      let listener = {
        success: function () {
          that.$message({
            type: 'success',
            message: '操作成功！ '
          })
          that.$refs.usedCarSouceSwitchManagementTable.search()
        },
        error: function () {
          that.$message({
            type: 'error',
            message: '操作失败！ '
          })
        }
      }
      channelModel.updateChannelUsedCarSwitch(that, param, listener)
    },
    onDataFilter: function (dataInfo) {
      this.data = dataInfo.data
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.usedCarSouceSwitchManagementTable.search()
    }
  },
  filters: {}
}
</script>

<style scoped>
</style>
